export default __webpack_public_path__ + "static/coconogacco-foundation-logo-fbd3c5f4508ab25caa5af25720a0b3aa.jpg";